declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleMedicineDataRequest, SaveClinicalOrderRxHeaderInfoRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'ngbaddprescriptionmedicine',
    templateUrl: './addprescriptionmedicine.modal.html',
    styleUrls: ['./addprescriptionmedicine.modal.scss']
})

export class NgbAddPrescriptionMedicineModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
    @Input() CurrentSaveClinicalOrderRxHeaderInfoRequest: SaveClinicalOrderRxHeaderInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;

  public isRequesting: boolean = false;
    public ShowService: boolean = true;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    @Input() MedicineName: string;
  @Input() ActivityCode: number;
  @Input() CycleCode: number;
  @Input() ActorCode1: number;
  @Input() MedicineCode: number;
  @Input() ClinicalOrderItem: number;
    @Input() ScanDate: Date;
    @Input() TcModelName: string;
    @Input() Typeofscreen: string;
    public Purpose: string;
    public Dose: string;
    public DurationType: string;
    public Route: string;
    public Frequency: string;
    public Instructions: string;
    public Orderentrycode: number;
    StartDate: NgbDateStruct;
    ToDate: NgbDateStruct;
  EndDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, private parserFormatter: NgbDateParserFormatter,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService) { }
  ActorCode: number;
  ngOnInit() {
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.ShowService = false;
    //alert(this.Typeofscreen);
      this.StartDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
      this.ToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      if (this.ScanDate != null) {
          var SValidFrom = new Date(this.ScanDate);
          if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.StartDate = {

                  year: SValidFrom.getFullYear(),
                  month: SValidFrom.getMonth() + 1,
                  day: SValidFrom.getDate()
              }
          }
      }
  }

    CurrentMedicineDetails: Array<MedicineDetails>;

    ReturnData() {
       // alert(this.DurationType);
        if (this.CurrentMedicineDetails == null) {
            this.CurrentMedicineDetails = new Array<MedicineDetails>();
        }
        if (this.CurrentMedicineDetails != null) {
            var row = new MedicineDetails();
            row.Dose = this.Dose;
            row.DurationType = this.DurationType;
            row.Frequency = this.Frequency;
            row.Instructions = this.Instructions;
            row.MedicineName = this.MedicineName;
            row.MedicineCode = 0;
            row.Purpose = this.Purpose;
            row.Route = this.Route;
            row.StartDate = new Date(this.parserFormatter.format(this.StartDate));
            row.ToDate = new Date(this.parserFormatter.format(this.ToDate));
            this.CurrentMedicineDetails.push(row);
            //alert(this.CurrentMedicineDetails[0].MedicineName);
        }
        //this.activeModal.close(this.CurrentMedicineDetails);
        this.passEntry.emit({ make: this.CurrentMedicineDetails });
        this.activeModal.close();
    }




  onSubmit() {

      this.StartRefreshing();
      this.spinner.show();
      //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
      this.CurrentSaveClinicalOrderRxHeaderInfoRequest.ConditionalOperator = 10;
      this.CurrentSaveClinicalOrderRxHeaderInfoRequest.DoseNumeric = 0;
      this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Duration = 0;
      this.CurrentSaveClinicalOrderRxHeaderInfoRequest.StartDate = new Date(this.parserFormatter.format(this.StartDate));
      this.CurrentSaveClinicalOrderRxHeaderInfoRequest.EndDate = new Date(this.parserFormatter.format(this.ToDate));
   
      this.actorservice.SaveClinicalOrderRxHeaderInfo(this.CurrentSaveClinicalOrderRxHeaderInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        
          if (result.Result[0].ClinicalOrderEntry > 0) {
              //if (!this.ApiResData.hasError) {

              //   if (this.ApiResData.Result > 0) {
              this.Orderentrycode = this.ApiResData.Result[0].ClinicalOrderEntry;
              //alert(this.Orderentrycode);
              this.passEntry.emit({ Orderentrycode: this.Orderentrycode });
              this.activeModal.close();
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.clear();
              // this.Listview = true;
              //this.EditEmbryo = false;
              //this.LoadStoreData();
              //this.AddEmbryo = false;
              //this.spinner.hide();
              //this.activeModal.close();
              //this.clearData();
              // this.LoadScansData();
              this.stopRefreshing();
              this.spinner.hide();
          }
          else {
              alertFunctions.AlertParam("Invalid Operation :- " + "...!");

              //this.spinner.hide();
              this.stopRefreshing();
              this.spinner.hide();
          }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
              alertFunctions.AlertParamEr(error);
              this.spinner.hide();
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
    clear() {
        this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Purpose = null;
       this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Dose = null;
        this.CurrentSaveClinicalOrderRxHeaderInfoRequest.DurationType = null;
        this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Route = null;
        this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Frequency = null;
        this.CurrentSaveClinicalOrderRxHeaderInfoRequest.Instructions = null;


    }
  onAssignedToActorCode(event: any) {

    if (event != null) {
      //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = event;
      this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = event;
      //alert( this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode)
      // console.log('event--_>' + event);
      //   }
    }

  }



}
export class MedicineDetails {

    public MedicineName: string;
    public MedicineCode: number;
    public Purpose: string;
    public Dose: string;
    public DurationType: string;
    public Route: string;
    public Frequency: string;
    public Instructions: string;
    public StartDate: Date;
    public  ToDate:Date ;

}
